export default "__VITE_ASSET__e7f9d104__"